import React, { useState } from 'react';
import { LogoOption1, LogoOption2, LogoOption3, LogoOption4 } from './LogoOptions';

const LogoPreviewPage = () => {
  const [selected, setSelected] = useState(1);

  const logos = [
    { 
      id: 1, 
      name: 'Snowflake Cooling', 
      component: LogoOption1, 
      description: 'Modern gradient badge with cooling icon & cyan accent dot',
      style: 'Modern & Professional'
    },
    { 
      id: 2, 
      name: 'Shield Badge HBS', 
      component: LogoOption2, 
      description: 'Bold monogram shield with "HBS" letters',
      style: 'Strong & Corporate'
    },
    { 
      id: 3, 
      name: 'AC Unit Circle', 
      component: LogoOption3, 
      description: 'Circular badge with AC vent lines',
      style: 'Technical & Industry'
    },
    { 
      id: 4, 
      name: 'Minimalist Clean', 
      component: LogoOption4, 
      description: 'Simple "H" in bordered square',
      style: 'Elegant & Minimal'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">Choose Your Logo Design</h1>
          <p className="text-xl text-gray-600">Select your favorite logo for HVAC Best Supply</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {logos.map(({ id, name, component: LogoComponent, description, style }) => (
            <div
              key={id}
              onClick={() => setSelected(id)}
              className={`bg-white rounded-2xl p-8 shadow-xl cursor-pointer transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 ${
                selected === id ? 'ring-4 ring-blue-600 bg-blue-50' : ''
              }`}
            >
              <div className="flex flex-col">
                {/* Logo Preview */}
                <div className="mb-6 p-8 bg-gray-50 rounded-xl flex justify-center">
                  <LogoComponent />
                </div>

                {/* Logo Info */}
                <div className="text-center">
                  <div className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-semibold mb-3">
                    {style}
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    Option {id}: {name}
                  </h3>
                  <p className="text-gray-600 mb-4">{description}</p>
                  
                  {selected === id ? (
                    <div className="bg-blue-600 text-white px-6 py-3 rounded-full text-sm font-bold inline-flex items-center gap-2">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                      </svg>
                      SELECTED
                    </div>
                  ) : (
                    <button className="bg-gray-200 text-gray-700 px-6 py-3 rounded-full text-sm font-semibold hover:bg-gray-300 transition">
                      Select This Logo
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Preview Section */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Preview on Website Header</h2>
          
          {/* Header Preview */}
          <div className="bg-white border-b-2 border-gray-200 p-6 rounded-lg mb-6">
            <div className="container mx-auto flex justify-between items-center">
              {selected === 1 && <LogoOption1 />}
              {selected === 2 && <LogoOption2 />}
              {selected === 3 && <LogoOption3 />}
              {selected === 4 && <LogoOption4 />}
              
              <div className="flex gap-6 text-gray-600 text-sm">
                <span>Products</span>
                <span>About</span>
                <span>Contact</span>
              </div>
            </div>
          </div>

          {/* Mobile Preview */}
          <div className="text-center mb-6">
            <h3 className="text-lg font-semibold text-gray-700 mb-4">Mobile View</h3>
            <div className="inline-block bg-gray-100 border-2 border-gray-300 rounded-xl p-4 max-w-sm">
              <div className="bg-white p-4 rounded-lg">
                {selected === 1 && <LogoOption1 />}
                {selected === 2 && <LogoOption2 />}
                {selected === 3 && <LogoOption3 />}
                {selected === 4 && <LogoOption4 />}
              </div>
            </div>
          </div>

          <div className="text-center">
            <p className="text-gray-600 mb-4">
              Current selection: <span className="font-bold text-blue-600">Option {selected}</span>
            </p>
            <p className="text-sm text-gray-500">
              Reply with your choice (1, 2, 3, or 4) and I'll apply it to your website!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoPreviewPage;
